import React from "react";

import { useFastshiftSelector } from "../../../state";

import { EmptyAssessmentSummary } from "./empty-assessment-summary";
import { MigrationSummary } from "./migration-summary";

export const MigrationSummarySection: React.FC = () => {
    const { l1Assessments, migrationPlanTotals, instances, selectedOrg } =
        useFastshiftSelector((state) => ({
            l1Assessments: state.l1Assessments,
            migrationPlanTotals: state.migrationPlanTotals,
            instances: state.instances,
            selectedOrg: state.selectedOrg
        }));

    const isLoading =
        l1Assessments.pending ||
        migrationPlanTotals.pending ||
        instances.pending ||
        !selectedOrg;

    const hasData =
        l1Assessments.data.length > 0 ||
        migrationPlanTotals.data.totalPlansCompleted > 0 ||
        migrationPlanTotals.data.totalPlansUnsuccessful > 0 ||
        migrationPlanTotals.data.totalPlansRunning > 0;

    const hasErrors =
        l1Assessments.error || migrationPlanTotals.error || instances.error;
    // Show MigrationSummary while loading or when there's data or errors
    // Only show EmptyAssessmentSummary when loading is complete AND no data
    const showEmpty = !isLoading && !hasData && !hasErrors;

    return showEmpty ? <EmptyAssessmentSummary /> : <MigrationSummary />;
};
